export const positionNumberAndName = (position: GQL.IPosition | null): string => {
  if (position) {
    return `${position.code}: ${position.name}`;
  }

  return '';
};
